import {KpiType} from '@hconnect/common/types'
import {Moment} from 'moment-timezone'

export const getRegionalManagerCommentsCategoryInstanceId = (kpiType: KpiType, date: Moment) => {
  const year = date.year()
  const month = date.month() + 1 // Months are zero-based in JavaScript

  return `${kpiType}-${year}-${month}`
}

export const parseRegionalManagerCommentsCategoryInstanceId = (
  categoryInstanceId: string
): {kpiType: KpiType; year: number; month: number} | undefined => {
  const parts = categoryInstanceId.split('-')
  if (parts.length !== 3) {
    return undefined
  }

  const [kpiTypeStr, yearStr, monthStr] = parts
  const kpiType = kpiTypeStr as KpiType
  const year = parseInt(yearStr, 10)
  const month = parseInt(monthStr, 10)

  if (isNaN(year) || isNaN(month) || month < 1 || month > 12) {
    return undefined
  }

  return {kpiType, year, month}
}
